<!-- Breadcromb Area Start -->
<section class="jobguru-breadcromb-area">
  <div class="breadcromb-top section_100">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcromb-box">
            <h3>{{pageName}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcromb-bottom">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcromb-box-pagin">
            <ul>
              <li><a routerLink="" (click)="goToHome()">home</a></li>
              <li><a routerLink="/dashboard/dashboard-statistics">dashboard</a></li>
              <li class="active-breadcromb"><a>{{pageName}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Breadcromb Area End -->
